




























import { defineComponent, onMounted, ref, watch } from '@vue/composition-api';
import { useEditField } from '@/store/modules/fields';
import { Address, ContactPoint, Field } from '@/store/types';
import { hasMinimumLength, isNotEmpty } from '@/utils/rules';
import AddressForm from './AddressForm.vue';
import ContactPointsForm from './ContactPointsForm.vue';

export default defineComponent({
	components: { AddressForm, ContactPointsForm },
	props: {
		field: {
			type: Object as () => Field,
			required: true,
		},
	},
	emits: ['close'],
	setup(props, { root, emit }) {
		const form = ref();
		const name = ref<string>('');
		const producerName = ref<string>('');
		const address = ref<Address | undefined>();
		const contactPoints = ref<Array<ContactPoint>>([]);
		const { editField, clearError, isLoading, hasError } = useEditField(root.$store);

		const assignValues = (field: Field) => {
			name.value = field.name;
			producerName.value = field.producerName;
			address.value = { ...field.address };
			contactPoints.value = field.contactPoints.map((contactPoint) => ({ ...contactPoint }));
		};

		const handleClose = () => {
			assignValues(props.field);
			clearError();
			form.value.resetValidation();
			emit('close');
		};

		const handleSubmit = async () => {
			clearError();

			if (!form.value.validate()) {
				return;
			}

			const success = await editField({
				id: props.field.id,
				name: name.value,
				producerName: producerName.value,
				address: address.value,
				contactPoints: contactPoints.value,
			});

			if (success) {
				root.$store.dispatch('resources/getAllResources');
				handleClose();
			}
		};

		onMounted(() => {
			assignValues(props.field);
		});

		watch(
			() => props.field,
			(field) => assignValues(field)
		);

		return {
			form,
			name,
			producerName,
			address,
			contactPoints,
			handleSubmit,
			handleClose,
			hasMinimumLength,
			isNotEmpty,
			isLoading,
			hasError,
		};
	},
});
